export const selectUser = (state) => state.user;

export const selectLogin = (state) => state.login;
